package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Motion
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Shadow
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.focusRingOutline
import co.maytes.standupbot.dashboard.styles.hoverFinePointer
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.toModifier

val CardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Palette.surface)
            .styleModifier {
                property("border", "1px solid ${Palette.border.cssRgb()}")
                property("box-shadow", Shadow.XS)
                property("transition", Motion.TRANSITION_BASE)
            }
    }
}

val InteractiveCardStyle = CssStyle {
    hoverFinePointer {
        Modifier.styleModifier { property("box-shadow", Shadow.MD) }
    }
    focusVisible {
        Modifier.focusRingOutline()
    }
}

@Composable
fun Card(
    modifier: Modifier = Modifier,
    padded: Boolean = true,
    interactive: Boolean = false,
    content: @Composable () -> Unit,
) {
    Column(
        modifier = CardStyle.toModifier()
            .let { if (interactive) it.then(InteractiveCardStyle.toModifier()) else it }
            .borderRadius(Radius.md)
            .let { if (padded) it.padding(Spacing.lg) else it }
            .then(modifier),
        horizontalAlignment = Alignment.Start,
    ) {
        content()
    }
}

internal fun org.jetbrains.compose.web.css.CSSColorValue.cssRgb(): String = toString()
